<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Players',

  components: {
    MyHeader,
    SideNav,
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Player search',
          route: {name: 'player_search'},
        },
        {
          title: 'Mass pendings',
          route: {name: 'players_pendings'},
        },
        {
          title: 'Mass payment restores',
          route: {name: 'players_payment_restores'},
        },
        {
          title: 'Suspected players',
          route: {name: 'suspected_players'},
        },
        {
          title: 'Events blocking',
          route: {name: 'events_blocking'},
        },
      ];

      return items;
    },
  },
};
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  min-width: 600px;
  max-width: 600px;
  padding-top: 0.6em;
}
</style>
